import { categories } from "@/mocks/site";

interface CaseFilterBarProps {
  activeCategory: string;
  onCategoryChange: (key: string) => void;
  query: string;
  onQueryChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  total: number;
}

const sortOptions = [
  { value: "latest", label: "最新发布" },
  { value: "hot", label: "阅读最多" },
  { value: "title", label: "按标题排序" },
];

export default function CaseFilterBar({
  activeCategory,
  onCategoryChange,
  query,
  onQueryChange,
  sort,
  onSortChange,
  total,
}: CaseFilterBarProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col lg:flex-row gap-4 lg:items-center lg:justify-between">
        <div className="relative flex-1 max-w-md">
          <i
            className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base"
            aria-hidden="true"
          ></i>
          <input
            type="search"
            value={query}
            onChange={(event) => onQueryChange(event.target.value)}
            placeholder="搜索关键词，如「增项」「押金」「返点」"
            aria-label="搜索调查档案"
            className="w-full pl-10 pr-4 py-2.5 rounded-md bg-background-100 border border-background-300 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
          />
        </div>

        <div className="flex items-center gap-3">
          <label className="flex items-center gap-2 text-sm text-foreground-600 whitespace-nowrap">
            排序
            <span className="relative">
              <select
                value={sort}
                onChange={(event) => onSortChange(event.target.value)}
                aria-label="排序方式"
                className="appearance-none pl-3 pr-9 py-2.5 rounded-md bg-background-100 border border-background-300 text-sm text-foreground-950 focus:outline-none focus:border-primary-400 cursor-pointer"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              <i
                className="ri-arrow-down-s-line absolute right-2.5 top-1/2 -translate-y-1/2 text-foreground-400 pointer-events-none"
                aria-hidden="true"
              ></i>
            </span>
          </label>
          <span className="hidden sm:inline text-xs text-foreground-500 whitespace-nowrap">
            共 {total} 篇
          </span>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onCategoryChange("all")}
          className={`px-3.5 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
            activeCategory === "all"
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
        >
          全部
        </button>
        {categories.map((category) => (
          <button
            key={category.key}
            type="button"
            onClick={() => onCategoryChange(category.key)}
            className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-xs font-medium transition-colors cursor-pointer whitespace-nowrap ${
              activeCategory === category.key
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            <i className={category.icon} aria-hidden="true"></i>
            {category.label}
          </button>
        ))}
      </div>
    </div>
  );
}